import { render, staticRenderFns } from "./ProjectPOABudgetAvailable.vue?vue&type=template&id=e8ffe93e"
import script from "./ProjectPOABudgetAvailable.vue?vue&type=script&lang=js"
export * from "./ProjectPOABudgetAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports